import React from "react";

import { LogoLoader } from "@performyard/py-components";

interface ReviewCycleLoaderProps {
	text: string;
	textArray?: string[];
}

const ReviewCycleLoader: React.FC<ReviewCycleLoaderProps> = ({ text, textArray = undefined }) => {
	return (
		<div className="flex h-[calc(100vh-104px)] flex-col items-center justify-center">
			<LogoLoader textArray={textArray || []} mainText={text} />
		</div>
	);
};

export default ReviewCycleLoader;
